import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import ProfilePage from './pages/admin/ProfilePage';
import ProjectsPage from './pages/admin/ProjectsPage';
import DocumentsPage from './pages/admin/DocumentsPage';
import PersonaPage from './pages/admin/PersonaPage';
import RecruitersPage from './pages/admin/RecruitersPage';
import TrackingPage from './pages/admin/TrackingPage';
import VisitorPage from './pages/VisitorPage';

function ProtectedRoute({ children }) {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
    return children;
}

function AppRoutes() {
    return (
        <Routes>
            {/* Visitor chat */}
            <Route path="/r/:slug" element={<VisitorPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="projects" element={<ProjectsPage />} />
                <Route path="documents" element={<DocumentsPage />} />
                <Route path="persona" element={<PersonaPage />} />
                <Route path="recruiters" element={<RecruitersPage />} />
                <Route path="tracking" element={<TrackingPage />} />
            </Route>

            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </BrowserRouter>
    );
}
